module.exports = __webpack_public_path__ + "static/media/6.4bab8d48.svg";